import React, { Fragment, useState, useCallback } from "react";
import { forgot, handleCloseModal, requestForgot } from "#app/store/actions/auth";
import { connect } from "react-redux";
import { Container, GreyText, Text, Wrapper } from "./styles";
import { Button, Input, InputContainer } from "finform";
import { Modal } from "#app/interface/modal/Modal";
import { Row } from "../styles";
import {
    ForgotProps,
    ForgotForm,
    ForgotActionParams,
    FormErrors,
    ForgotOwnProps,
    ForgotReduxProps,
} from "./types";

const Forgot: React.FC<ForgotProps> = ({
    forgot: forgotAction,
    requestForgot: requestForgotAction,
    handleCloseModal,
    callback,
}) => {
    const [form, setForm] = useState<ForgotForm>({
        email: "",
        password: "",
        password_confirmation: "",
        code: "",
        captchaValue: "",
        form: "manager",
    });
    const [formErrors, setFormErrors] = useState<FormErrors>({});
    const [code, setCode] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [checked, setChecked] = useState(false);

    const getError = useCallback(
        (fieldName: string): string | undefined => {
            if (
                formErrors &&
                typeof formErrors[fieldName] !== "undefined" &&
                formErrors[fieldName]?.length &&
                formErrors[fieldName]!.length > 0
            ) {
                return formErrors[fieldName]![0];
            }
            return undefined;
        },
        [formErrors]
    );

    const updateFormField = useCallback((field: keyof ForgotForm, value: string) => {
        setForm((prev) => ({
            ...prev,
            [field]: value,
        }));
        setFormErrors((prev) => ({
            ...prev,
            [field]: undefined,
        }));
    }, []);

    const submitRequestForgotForm = useCallback(() => {
        setSubmitted(true);

        const params: ForgotActionParams = {
            form,
            success: (response, status, xhr) => {
                setCode(true);
                setSubmitted(false);
            },
            error: (errors) => {
                setSubmitted(false);
            },
            obj: undefined,
        };
        requestForgotAction(params);
    }, [form, requestForgotAction]);

    const submitForgotForm = useCallback(() => {
        setSubmitted(true);

        const params: ForgotActionParams = {
            form,
            success: (response, status, xhr) => {
                Modal.handleClose();
                handleCloseModal();

                setForm({
                    email: "",
                    password: "",
                    password_confirmation: "",
                    captchaValue: "",
                    code: "",
                    form: "manager",
                });
                setSubmitted(false);

                if (typeof callback === "function") {
                    callback();
                }
            },
            error: (errors) => {
                setSubmitted(false);
            },
            obj: undefined,
            callback: () => {},
        };
        forgotAction(params);
    }, [form, forgotAction, handleCloseModal, callback]);

    const submitForm = useCallback(() => {
        if (code) {
            submitForgotForm();
        } else {
            submitRequestForgotForm();
        }
    }, [code, submitForgotForm, submitRequestForgotForm]);

    const renderCodeForm = () => {
        return (
            <Wrapper>
                <Container>
                    <Fragment>
                        <Text>Введите код отправленный на email </Text>
                        <Row>
                            <InputContainer error={getError("code")}>
                                <Input
                                    id="forgot-code"
                                    type="text"
                                    name="code"
                                    value={form.code || ""}
                                    onChange={
                                        ((value: string | number) => {
                                            updateFormField("code", String(value));
                                        }) as any
                                    }
                                    placeholder={"Код"}
                                />
                            </InputContainer>
                        </Row>
                        <h3>Придумайте новый пароль</h3>
                        <Row>
                            <InputContainer error={getError("password")}>
                                <Input
                                    id="forgot-password"
                                    type="password"
                                    name="password"
                                    value={form.password || ""}
                                    onChange={
                                        ((value: string | number) => {
                                            updateFormField("password", String(value));
                                        }) as any
                                    }
                                    placeholder={"Новый пароль"}
                                />
                            </InputContainer>
                        </Row>
                        <Row>
                            <InputContainer error={getError("password_confirmation")}>
                                <Input
                                    id="forgot-password_confirmation"
                                    type="password"
                                    name="password_confirmation"
                                    value={form.password_confirmation || ""}
                                    onChange={
                                        ((value: string | number) => {
                                            updateFormField("password_confirmation", String(value));
                                        }) as any
                                    }
                                    placeholder={"Повтор нового пароля"}
                                />
                            </InputContainer>
                        </Row>
                    </Fragment>
                    <GreyText>(напишите на info@blackswan.finance если код не приходит)</GreyText>
                    <Row>
                        <Button wide id="forgot-submit" onClick={submitForm}>
                            Сохранить
                        </Button>
                    </Row>
                </Container>
            </Wrapper>
        );
    };

    const renderForgotForm = () => {
        return (
            <Wrapper>
                <Container>
                    <Row>
                        <InputContainer error={getError("email")}>
                            <Input
                                id="forgot-email"
                                type="text"
                                name="email"
                                value={form.email}
                                onChange={
                                    ((value: string | number) => {
                                        updateFormField("email", String(value));
                                    }) as any
                                }
                                placeholder={"Email"}
                            />
                        </InputContainer>
                    </Row>
                    <Row>
                        <Button wide className="style2" id="forgot-submit" onClick={submitForm}>
                            Восстановить
                        </Button>
                    </Row>
                </Container>
            </Wrapper>
        );
    };

    if (code) {
        return renderCodeForm();
    } else {
        return renderForgotForm();
    }
};

const enhance = connect<{}, ForgotReduxProps, ForgotOwnProps, {}>(() => ({}), {
    forgot,
    requestForgot,
    handleCloseModal,
} as any);

export default enhance(Forgot);
